import React from 'react';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { Alert } from '@brokerbay/design-components';
import {
  Select,
  Input,
  InputNumber,
  List,
  ListItem,
  Text,
  DatePicker,
  Dragger,
  theme,
  RadioGroup,
} from 'components';

type StyledGridProps = React.PropsWithChildren<{
  $columns?: 1 | 2 | 3;
  $alignItems?: string;
  $rowGap?: string;
}>;

export const StyledGrid: React.FC<StyledGridProps> = props => {
  const { md, lg } = useBreakpoint();
  return <StyledInnerGrid $md={md} $lg={lg} {...props} />;
};

const StyledInnerGrid = styled.div<
  StyledGridProps & { $md: boolean; $lg: boolean }
>`
  display: grid;
  ${({ $columns, $lg, $md }) => {
    let cols = $columns;
    if (!$lg) {
      if (!$md) cols = 1;
      else cols = 2;
    }
    return `grid-template-columns: repeat(${cols}, 1fr)`;
  }};
  grid-column-gap: 25px;
  grid-row-gap: ${({ $rowGap = '10px' }) => $rowGap};
  max-width: 100%;
  align-items: ${({ $alignItems = 'flex-end' }) => $alignItems};
  ${Select}, ${Input}, ${InputNumber}, ${DatePicker} {
    width: 100%;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 15px;
`;

export const StyledAgentList = styled(List)`
  max-height: 200px;
  overflow: auto;
  ${ListItem} {
    padding: 0;
    border: none;
    display: grid;
    grid-auto-flow: column;
    gap: 5px;
    padding-right: 5px;
    overflow: hidden;
  }
`;

export const StyledTableCell = styled.div<{ $minWidth: number }>`
  min-width: ${({ $minWidth }) => $minWidth}px;
`;

export const StyledDragger = styled(Dragger)<{ $maxWidth?: string }>`
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}`};
  margin: auto;
`;

export const StyledSubdivisionName = styled.div`
  width: auto;
  span {
    margin-left: 5px;
  }
`;
